export default {
      id: "local_grocery_store-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.845ff42f.svg#local_grocery_store",
      toString: function () {
        return this.url;
      }
    }